/*
 * Rebuy -> theme cart sync
 * Rebuy adds to cart through its own requests, so the header cart bubble isn't updated.
 * After a Rebuy add / cart change, refetch the cart and update the bubble + cart drawer.
 */
(function () {
    let timer;

    const updateBubble = async () => {
        try {
            const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
            if (!res.ok) return;
            const cart = await res.json();

            document.querySelectorAll('.cart-link__bubble-num').forEach((el) => {
                el.textContent = cart.item_count;
            });
            document.querySelectorAll('.cart-link__bubble').forEach((el) => {
                el.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
            });

            // Rebuild the theme cart drawer if present (CartForm listens for this)
            document.dispatchEvent(new CustomEvent('cart:build'));
        } catch (e) {
            console.warn('Rebuy cart bubble sync failed', e);
        }
    };

    // Debounce: Rebuy can fire several events for one add
    const scheduleUpdate = () => {
        clearTimeout(timer);
        timer = setTimeout(updateBubble, 300);
    };

    document.addEventListener('rebuy.add', scheduleUpdate);
    document.addEventListener('rebuy:cart.change', scheduleUpdate);
})();
